import React, { MouseEventHandler } from "react";
import "./styles.scss";

interface CardProps {
  className?: string;
  children?: JSX.Element | JSX.Element[] | string;
  onClick?: MouseEventHandler;
  actionsArea?: JSX.Element | JSX.Element[] | string;
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  actionsArea,
  ...props
}) => (
  <div
    {...props}
    className={`${className} flex flex-wrap flex-col justify-center max-w-full card
       p-8 bg-white rounded-md ${props.onClick !== undefined && "clickable"}`}
    // style={{ width: '36rem' }}
  >
    {children}
    {actionsArea !== undefined && (
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex flex-col w-full md:flex-row md:w-fit gap-4 md:justify-end md:items-end mt-8 self-end"
      >
        {actionsArea}
      </div>
    )}
  </div>
);

export default Card;
